import { createAction } from '@reduxjs/toolkit';

export const REJECT_SMS_ACTION_TYPE = 'saga/rejectSms';
export const rejectSmsAction = createAction(REJECT_SMS_ACTION_TYPE);
